<div class="ModeDiv">
	<label>View:</label>
	<select class="form-control" name="ModeID" [(ngModel)]="ModeID">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstMode" [ngValue]="o.ID">{{ o.Desc }}</option>
	</select>
</div>

<caass-district-calendar-main-view *ngIf="ModeID == 1"></caass-district-calendar-main-view>

<caass-district-calendar-holiday-view *ngIf="ModeID == 2"></caass-district-calendar-holiday-view>
